import api from '../../api';
import { TPunterSupportedBetsResponse } from './supportedBets.types';

export const punterSupportedBets = '/punter/account/supported-bets';
export const queryPunterSupportedBets = () =>
  api
    .get<TPunterSupportedBetsResponse>(punterSupportedBets)
    .then((res) => res.data);
